module.exports = "/images/logo-bas-02-4b5079a316be3d6d18296eee4c10c37b.png";